import React from "react";
import Header from "../../../Home/Header";
import Footer from "../../../Home/Footer";
import AssentTekenizationHero from "./AssentTekenizationHero";
import WhyTokenize from "./WhyTokenize";
import AssetTokSer from "./AssetTokSer";
import OurAssetTok from "./OurAssetTok";

function AssentTekenization() {
  return (
    <div>
      <Header />
      <AssentTekenizationHero />
      <WhyTokenize />
      <AssetTokSer />
      <OurAssetTok />
      <Footer />
    </div>
  );
}

export default AssentTekenization;
